<div class="robotics-simulator">
  <div id="robotics-container"></div>
  <div class="control-buttons">
    <!-- <button (click)="reCenter()">Re-center</button> -->
    <button (click)="zoom('in')">Zoom In</button>
    <button (click)="zoom('out')">Zoom Out</button>
  </div>
</div>
